import { uniqueIdentifierForNode } from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlNode } from '@ctw/shared/utils/cda/types';
import { type ReactNode, memo } from 'react';
import { PdfNodeRenderer } from './pdf-node-renderer';

interface PdfHtmlRendererProps {
  id: string;
  parsedHtmlNodes: Array<CdaParsedHtmlNode>;
  emptyState?: ReactNode;
}

export const PdfHtmlRenderer = memo(({ id, parsedHtmlNodes, emptyState }: PdfHtmlRendererProps) => {
  if (parsedHtmlNodes.every((node) => node.isEffectivelyEmpty)) {
    return emptyState ?? null;
  }

  return (
    <>
      {parsedHtmlNodes.map((node, index) => {
        const nodeIdentifier = uniqueIdentifierForNode({
          node: node,
          index,
          context: id,
          purpose: 'html-child',
        });

        return <PdfNodeRenderer id={nodeIdentifier} key={nodeIdentifier} node={node} />;
      })}
    </>
  );
});
